import { useEffect, useMemo, useState } from 'react';
import useDocumentService from '../../../../hooks/useDocumentService';
import { EnumsValues } from '../../../../enums/EnumsValues';

interface GetDocumentPdfProps {
  documentId?: number;
}

const useGetDocumentPdf = (props: GetDocumentPdfProps) => {
  const { documentId } = props;

  const { getDocumentPdf } = useDocumentService();

  const [pdfBase64, setPdfBase64] = useState<string>('');
  const [loadingPdf, setLoadingPdf] = useState<boolean>(false);

  const getDocumentFile = async (documentId: number) => {
    try {
      setLoadingPdf(true);
      const data = await getDocumentPdf(documentId);
      setPdfBase64(data?.file);
    } catch (error) {
      //intentional
    } finally {
      setLoadingPdf(false);
    }
  };

  useEffect(() => {
    if (documentId) {
      getDocumentFile(documentId);
    }
  }, []);

  const isPdfLoading = useMemo(() => {
    return loadingPdf;
  }, [loadingPdf]);

  return {
    pdfBase64: EnumsValues.FileDataType.PdfBase64 + pdfBase64,
    isPdfLoading,
  };
};
export default useGetDocumentPdf;
